export const login_path = '/auth';
export const home_path = '/';
export const default_path = '/app';
export const privacy_info = '/privacy';